// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"en-z","slideIn":"fn-z"};